module.exports = __webpack_public_path__ + "static/img/t2.30598a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/home/t2.png
// module id = TFfP
// module chunks = 1